<app-campaign-header [event]="campaignStatsSubject.asObservable()" [filtersApplied]="filtersInfoSubjecct.asObservable()"></app-campaign-header>

<!-- Container is visible when campaign has zero candidate -->
<div *ngIf="showAddCandidatePage && !isAnyFiltersApplied && !(isPipelineFilterSelected || isCompletedFilterSelected || isOpenedFilterSelected || isRepliedFilterSelected)" class="wccard p-4" style="color: #484b59; height: 100vh;">
  <div class="text-center f-16 font-weight-600 py-6">
    Add your first candidate from
  </div>
  <div class="card-container">

    <div class="campaign-card mr-2">
      <div class="mb-3 f-14 font-weight-600">Project</div>
      <div style="height: 157px;">
        <img src="../../../assets/images/email-campaing-start-2.png" style="max-width: 100%;" alt="">
      </div>

      <div class="d-flex flex-column justify-content-between align-items-center" style="height: 120px;">
        <div class="mt-4 text-center" style=" margin-bottom: 12px;">
          Select Candidate(s) from "Pipeline" section of your projects and add them into your email campaign
        </div>
        <div class="font-weight-500" style="cursor: pointer;" routerLink="/projects">
          Project
          <i class="fa-regular fa-arrow-up-right-from-square ml-1" ></i>
        </div>
      </div>
    </div>

    <div class="campaign-card mx-2">
      <div class="mb-3 f-14 font-weight-600">Search Results</div>
      <div style="height: 157px;">
        <img src="../../../assets/images/email-campaing-start-3.png" alt="" style="max-width: 100%;">
      </div>
      <div class="d-flex flex-column justify-content-between align-items-center" style="height: 120px;">

        <div class="mt-4 text-center" style=" margin-bottom: 12px;">
          Select candidate(s) from "Search results" and add them into your email campaign
        </div>
        <div class="font-weight-500" routerLink="/search"
        style="cursor: pointer;">
        Search Result
        <i class="fa-regular fa-arrow-up-right-from-square ml-1"></i>
      </div>
    </div>
    </div>

    <div class="campaign-card mx-2">
      <div class="mb-3 f-14 font-weight-600">My Candidates</div>
      <div style="height: 157px;">
        <img src="../../../assets/images/email-campaing-start-4.png" style="margin-bottom: 7px; max-width: 100%;" salt="">
      </div>
      <div class="d-flex flex-column justify-content-between align-items-center" style="height: 120px;">

        <div class="mt-4 text-center" style=" margin-bottom: 12px;">
          Select candidate(s) from "My Candidates" section and add them into your email campaign
        </div>
        <div class="font-weight-500" routerLink="/my-candidates" style="cursor: pointer;">
          My Candidates
          <i class="fa-regular fa-arrow-up-right-from-square ml-1" routerLink="/my-candidates"
          style="cursor: pointer;"></i>
        </div>
      </div>
    </div>

    <div class="campaign-card ml-2">
      <div class="mb-3 f-14 font-weight-600">Chrome Extension</div>
      <div style="height: 157px;">
        <img src="../../../assets/images/email-campaing-start-1.png" style="margin-bottom: 13px; max-width: 100%;" alt="">
      </div>
      <div class="d-flex flex-column justify-content-between align-items-center" style="height: 120px;">

        <div class="mt-4 text-center" style=" margin-bottom: 12px;">
          Fetch candidates profile & add them to campaign via this extension
        </div>
        <a data-testid="auto-app-campaign-listing-a-1" href="https://www.webbtree.com/chrome-extension" style="color: #484b59;">
          <div class="font-weight-500" href="https://www.webbtree.com/chrome-extension" style="cursor: pointer;">
            Add Chrome Extension
            <i class="fa-regular fa-arrow-up-right-from-square ml-1"></i>
          </div>
        </a>
      </div>
    </div>
  </div>
</div>


<div *ngIf="isBulkRevealInProcess" id="bulk-process">
  <span class="process-env">
    <i class="fa-solid fa-envelope"></i>
  </span>
  <!-- <span class="d-flex"> -->
    <span class="bulk-process-text">
      A process has been queued to bulk find contact and add to campaign. On completion a summary report will be sent to {{userEmailId}}
    </span>
    <i class="fa-solid fa-xmark float-right mr-2" style="color: #2e93a1; margin-top: 3px; cursor: pointer;" (click)="removeBulkProcessDiv()"></i>
  <!-- </span> -->
</div>

<!-- Candidate listing in a campaing -->
<div *ngIf="isTargetDataApiCalled && (!showAddCandidatePage || isAnyFiltersApplied)" style="color: #484b59;">
  <div class="wccard p-4">
    <!-- Campaign stats -->
    <div class="d-flex flex-column mb-3">
      <div class="font-weight-600 mb-2"> Candidate Source Funnel </div>
      <div class="d-flex">
        <div class="camp-stats mr-1 pointer" [ngStyle]="{'background-color': isPipelineFilterSelected ? '#F2F2F2' : ''}" (click)="campaignData?.stats?.pipeline && onStatsFilterSelected('pipeline')">
          <span>{{campaignData?.stats?.recipient || 0}}</span>
          <p>Candidates Added<i class="fa-light fa-circle-info ml-1" style="cursor: pointer;" matTooltip="Target candidates added in the campaign." [matTooltipClass]="{ 'red-tooltip text-black': true }"></i></p>
        </div>
        <div class="camp-stats mx-1" >
          <span>{{campaignData?.stats?.pipeline || 0}}</span>
          <p>Active<i class="fa-light fa-circle-info ml-1" style="cursor: pointer;" matTooltip="Candidates currently in progress and eligible to continue in the campaign." [matTooltipClass]="{ 'red-tooltip text-black': true }"></i></p>
        </div>
        <div class="camp-stats mx-1">
          <span>{{campaignData?.stats?.contacts?.available || 0}}</span>
          <p>Contact Available <i class="fa-light fa-circle-info ml-1" style="cursor: pointer;" matTooltip="Candidates with a usable email address for campaign outreach." [matTooltipClass]="{ 'red-tooltip text-black': true }"></i> </p>
        </div>
        <div class="camp-stats ml-1" >
          <span>{{campaignData?.stats?.contacts?.missing || 0}}</span>
          <p>Contact Not Available <i class="fa-light fa-circle-info ml-1" style="cursor: pointer;" matTooltip="Candidates without a usable email address for campaign outreach." [matTooltipClass]="{ 'red-tooltip text-black': true }"></i></p>
        </div>
      </div>
    </div>
    <div class="d-flex flex-column">
      <div class="font-weight-600 mb-2"> Engagement </div>
      <div class="d-flex">
        <div class="camp-stats mr-1 pointer" [ngStyle]="{'background-color': isPipelineFilterSelected ? '#F2F2F2' : ''}" (click)="campaignData?.stats?.pipeline && onStatsFilterSelected('pipeline')">
          <span>{{roundOff(campaignData?.stats?.delivered) || 0}}%</span>
          <p>Delivered<i class="fa-light fa-circle-info ml-1" style="cursor: pointer;" matTooltip="Candidates in the campaign who have been sent at least one email." [matTooltipClass]="{ 'red-tooltip text-black': true }"></i></p>
        </div>
        <div class="camp-stats mx-1 pointer" [ngStyle]="{'background-color': isOpenedFilterSelected ? '#F2F2F2' : ''}" (click)="campaignData?.stats?.opened && onStatsFilterSelected('opened')">
          <span>{{roundOff(campaignData?.stats?.opened) || 0}}%</span>
          <p>Opened <i class="fa-light fa-circle-info ml-1" style="cursor: pointer;" matTooltip="Candidates who opened at least one campaign email." [matTooltipClass]="{ 'red-tooltip text-black': true }"></i> </p>
        </div>
        <div class="camp-stats ml-1" >
          <span>{{roundOff(campaignData?.stats?.replied) || 0}}%</span>
          <p>Replied <i class="fa-light fa-circle-info ml-1" style="cursor: pointer;" matTooltip="Candidates who have replied to the email campaign." [matTooltipClass]="{ 'red-tooltip text-black': true }"></i></p>
        </div>
        <div class="camp-stats mx-1" >
          <span>{{roundOff(campaignData?.stats?.bounced) || 0}}%</span>
          <p>Bounced<i class="fa-light fa-circle-info ml-1" style="cursor: pointer;" matTooltip="Candidates who have at least one campaign email bounced." [matTooltipClass]="{ 'red-tooltip text-black': true }"></i></p>
        </div>
      </div>
    </div>
  </div>

  <div class="wccard mt-1 p-4">
    <!-- Filters and search bar -->
    <div class="d-flex justify-content-between">
      <div class="font-weight-600"> Candidates </div>

      <div class="d-flex align-items-center">
        <span class="btn-trms-small mr-3" style="cursor: pointer;" *ngIf="canEditCampaign && selectedTargetIds.size > 0" (click)="openRemoveConfirmForSelection()">
          <i class="fa-solid fa-trash mr-1"></i>Remove from Campaign ({{selectedTargetIds.size}})
        </span>
        <span class="search-candidate mx-4">
          <i class="fa-sharp fa-regular fa-magnifying-glass mr-1"></i>
          <input data-testid="auto-app-campaign-listing-input-1" type="text" (input)="typeaheadSearch($event)" placeholder="Search Candidate">
        </span>
        <span class="filter-btn"  [ngClass]="{'filtersSelected': emailFiltersApplied}" (click)="filterSlider_open()">
          <i class="fa-solid fa-filter mr-1"></i>Filters
        </span>
      </div>
    </div>
  </div>


  <!-- email campaign filter slider -->
  <app-email-campaign-filter [events]="stageDataSubject.asObservable()" (filterChange)="emailFilters($event)" [statusFilter]="statusFilter"></app-email-campaign-filter>

  <!-- target list table -->
  <div class="wccard mt-1" *ngIf="targetData?.length">

    <table mat-table class="w-100" [dataSource]="targetData">

      <!-- select -->
      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef class="col-1">
          <mat-checkbox *ngIf="canEditCampaign" [checked]="isAllSelected" (change)="toggleSelectAll($event.checked)"></mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let element">
          <mat-checkbox *ngIf="canEditCampaign" [checked]="selectedTargetIds.has(element?.campaign_target_id)" (change)="toggleSelect(element?.campaign_target_id, $event.checked)" (click)="$event.stopPropagation()"></mat-checkbox>
        </td>
      </ng-container>

      <!-- target_name -->
      <ng-container matColumnDef="target_name">
        <th mat-header-cell *matHeaderCellDef class="col-3">
          <p class="text-9696 f-14 m-0">Candidate Name</p>
        </th>
        <td mat-cell *matCellDef="let element" style="cursor: pointer;"  (click)="candidateSlider_open(element, 'details')">
          <p class="text-484b59 f-14 m-0 mt-2">{{element?.target_name | titlecase}}</p>
          <p class=" text-9696 mt-1">{{element?.title | titlecase}}</p>
        </td>
      </ng-container>

      <!-- target_email -->
      <ng-container matColumnDef="target_email">
        <th mat-header-cell *matHeaderCellDef class="col-3">
          <p class="text-9696 f-14 m-0">Email ({{emailType}})</p>
        </th>
        <td mat-cell *matCellDef="let element">
          <p class="f-14 m-0" style="color: #2c2c2c;" *ngIf="element?.target_email"> <i class="fa-solid fa-envelope mr-1 text-484b59"></i> {{element?.target_email}}</p>
          <p class="f-14 mt-1 mb-1" style="color: #2c2c2c;" *ngIf="!(element?.target_email) && element?.targetStatus === 8 && !element?.previewAvailable"> No Email found</p>
          <p class="f-12 m-0" style="color: #2e93a1; cursor: pointer; text-decoration: underline;" *ngIf="canEditCampaign && !(element?.target_email) && element?.targetStatus === 8 && !element?.previewAvailable" (click)="candidateSlider_open(element, 'contactTab', true)">Add Email ID manually</p>
          <p class="f-14 m-0" style="color: #2c2c2c;" *ngIf="!(element?.target_email) && element?.targetStatus === 7">  <i class="fa-solid fa-magnifying-glass"></i> Explore email</p>

          <span class="find-email ml-3" *ngIf="canEditCampaign && !(element?.target_email) && ((element?.targetStatus !== 8 && element?.targetStatus !==7) || element?.previewAvailable)" (click)="candidateSlider_open(element, 'contactTab', false)"> <i class="fa-sharp fa-solid fa-magnifying-glass mr-1"></i> Find Email</span>
        </td>
      </ng-container>

      <!-- Status -->
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef class="col-">
          <p class="text-9696 f-14 m-0">Status</p>
        </th>
        <td mat-cell *matCellDef="let element">
          <p class="f-14 m-0" *ngIf="element?.targetStatus == 9">
            Unsubscribed
          </p>
          <p class="f-14 m-0" *ngIf=" element?.targetStatus != 9 && element.steps == 0">
            Not started
          </p>
          <p class="f-14 m-0" *ngIf="element?.targetStatus != 9 && element?.steps != 0">
            <span *ngIf="element?.targetStatus === 3">Completed
              (<span>{{ element?.has_reply ? 'Replied' : (element?.status ? 'Opened' : 'Not opened') }}</span>)
            </span>
            <ng-container *ngIf="element?.targetStatus != 3">
              <span>{{ element?.status ? 'Opened' : 'Not opened' }}</span>
            </ng-container>
          </p>
        </td>
      </ng-container>

      <!-- steps -->
      <ng-container matColumnDef="steps">
        <th mat-header-cell *matHeaderCellDef class="col-2">
          <p class="text-9696 f-14 m-0">Steps</p>
        </th>
        <td mat-cell *matCellDef="let element">
          <p class="f-14 m-0" *ngIf="element?.steps != 0">
            Step : {{element?.steps}} / {{totalStages}}
          </p>
          <p class="f-14 m-0" *ngIf="element?.steps == 0">
            Not started
          </p>
        </td>
      </ng-container>

      <!-- date -->
      <ng-container matColumnDef="date">
        <th mat-header-cell *matHeaderCellDef class="col-2">
          <p class="text-9696 f-14 m-0">Added on</p>
        </th>
        <td mat-cell *matCellDef="let element">
          <div class="f-14 m-0 d-flex justify-content-between">
            {{getFormattedDate(element?.last_sent_on || element?.created_on)}}
            <span class="dropdown ml-2" *ngIf="canEditCampaign">
              <button data-testid="auto-app-campaign-listing-button-1" class="ats-btn btn-break ml-3px" type="button" id="userDropdownButton"
                appDropdownToggle aria-haspopup="true" aria-expanded="false">
                <i class="fas fa-ellipsis-v"></i>
              </button>
              <div class="dropdown-menu dropdown-menu-right" aria-labelledby="userDropdownButton">
                <a data-testid="auto-app-campaign-listing-a-2" class="dropdown-item f-12" (click)="markAsReplied(element?.campaign_target_id)"
                  *ngIf="element?.steps >= 1 && element?.targetStatus !== 3">
                  <i class="fa-solid fa-reply mr-1"></i>
                  Mark as Replied
                </a>
                <a data-testid="auto-app-campaign-listing-a-3" class="dropdown-item f-12" (click)="openRemoveConfirm([element?.campaign_target_id])">
                  <i class="fa-solid fa-trash mr-1 delete-icon"></i>
                  Remove from Campaign
                </a>
              </div>
            </span>

          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"
        style="background-color:#f6f6f6; color: #969696; border-radius: 2px;"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

    </table>
  </div>

  <div class="text-center" *ngIf="targetData?.length === 0 && isAnyFiltersApplied">
    No Data Available
  </div>

  <!-- email campaign candidate slider -->
  <app-email-campaign-candidate-slider [events]="candidateIdSubject.asObservable()" (targetEmailEvent)="eventHandler($event)"></app-email-campaign-candidate-slider>

</div>


<!-- pagination -->
<div class="d-flex justify-content-center wccard ng-star-inserted mt-1" *ngIf="!showAddCandidatePage && totalResultCount > 10">
  <ngb-pagination [collectionSize]="totalResultCount" [maxSize]="5" aria-label="Custom pagination" [pageSize]="pageSize" rotate="false" (pageChange)="setPage($event)" [(page)]="pageIndex" [ellipses]="false">
    <ng-template ngbPaginationPrevious> Previous </ng-template>
    <ng-template ngbPaginationNext> Next </ng-template>
  </ngb-pagination>
</div>

<ng-template #removeConfirmModal>
  <div class="modal-body">
    <div class="mb-3">
      <div class="header d-flex align-items-center" style="justify-content: space-between;">
        <div>
          <i class="fa-solid fa-trash mr-1" style="color: #d9534f;"></i>
          <span class="modal-heading">Remove from campaign</span>
        </div>
        <div>
          <span (click)="modalService.dismissAll()" style="cursor: pointer; color: #2c2c2c;">
            <i class="fa-regular fa-xmark"></i>
          </span>
        </div>
      </div>
    </div>
    <div>
      Remove {{pendingRemoveTargetIds.length}} candidate{{pendingRemoveTargetIds.length > 1 ? 's' : ''}} from this campaign? They will stop receiving further emails from it.
    </div>
    <div class="d-flex justify-content-end mt-3" style="gap: 8px;">
      <button data-testid="auto-app-campaign-listing-button-2" class="btn-trms-light" (click)="modalService.dismissAll()">Cancel</button>
      <button data-testid="auto-app-campaign-listing-button-3" class="btn-trms-small" (click)="confirmRemove()">Remove</button>
    </div>
  </div>
</ng-template>
